import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { darken } from '@material-ui/core/styles';

export const ProviderSidebarContainer = styled.div`
    ${({ theme }) => `
    background: ${theme.palette.common.white};

    box-shadow: 4px 0px 8px rgba(204, 208, 227, 0.5);
    backdrop-filter: blur(4px);

    flex-direction: column;
    padding-top: 24px;
    padding-left: 8px;
    width: 240px;
    `}
`;

export const StyledProviderMenuButton = styled(Button)`
    ${({ theme, selected }) => `
    background-color: ${selected ? theme.palette.common.dimBlue : theme.palette.common.white};
    border-radius: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 8px;
    padding: 0;
    text-transform: none;
    `}
`;

export const StyledIconButtonContainer = styled.div`
    ${({ theme, $backgroundColor }) => `
    background-color: ${
        $backgroundColor ? theme.palette.common[$backgroundColor] : theme.palette.primary.main
    };   
    &:hover {
        background-color: ${
            $backgroundColor
                ? darken(theme.palette.common[$backgroundColor], 0.1)
                : darken(theme.palette.primary.main, 0.1)
        };
          }
    min-width: 0;
    font-size: 16px;
    border-radius: 50%;
    height: 32px;
    width:  32px;
    padding: 5px;
    margin: 10px;

    display: flex;
    justify-content: center;
    align-items: center;

    &:disabled{
        cursor:not-allowed;
        color: #fff;
        background-color: ${theme.palette.common.gray7};
      }

  `}
`;

export const StyledSignOutButton = styled(Button)`
    ${({ theme }) => `
    background: ${theme.palette.common.white};
    border: 1px solid ${theme.palette.common.gray6};
    box-sizing: border-box;
    backdrop-filter: blur(4px);
    border-radius: 16px;
    padding: 10px 20px;
    width: 100%;
    height: 52px;
    justify-content: center;
    text-transform: none;
    `}
`;

export const StyledBalanceContainer = styled.div`
    ${({ theme }) => `
    width: 158px;
    height: 48px;
    padding: 10px;
    box-sizing: border-box;

    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr auto;
    column-gap: 10px;

    border: 1px solid ${theme.palette.common.gray6};
    border-radius: 24px;
    margin-top: 5px;
    `}
`;
